// src/apps/liff/pages/nps-page/components/RatingPage.jsx
import { Text, Button, Stack, Image, Group } from "@mantine/core";

export default function RatingPage({
	rating,
	setRating,
	showError,
	setShowError,
	goNext,
	memberData,
}) {
	const ratings = Array.from({ length: 10 }, (_, i) => i + 1);

	return (
		<Stack
			px="4.7vw"
			pt="24.42vw"
			pb="11.63vw"
			align="center"
			justify="space-between"
			h="100vh"
		>
			<Group w="100%" px="3.54vw" justify="center">
				<Image
					src={window.assetUrl("/images/liff/questionnaire-page/logo.png")}
					alt="Tory Burch"
					w="58%"
				/>
			</Group>

			<Stack spacing="xl" align="center" gap="xs">
				<Text align="center" size="3.76vw" lh="1.4">
					根據本次購物體驗，您推薦Tory Burch <br />
					{memberData.survey.store.display_name} 專門店的意願有多高?？
				</Text>

				<Group w="100%" mt="md" gap="1px">
					{ratings.map((num) => (
						<Button
							key={num}
							variant={rating === num ? "filled" : "default"}
							color="dark"
							radius="md"
							size="md"
							styles={{
								root: {
									width: "8.5vw",
									height: "8.5vw",
									padding: 0,
									border: "1px solid #DDDDDD",
									backgroundColor: rating === num ? "#000" : "#FFF",
									color: rating === num ? "#FFF" : "#000",
								},
							}}
							onClick={() => {
								setRating(num);
								setShowError(false);
							}}
						>
							{num}
						</Button>
					))}
				</Group>

				<Group w="100%" justify="space-between">
					<Text size="xs" color="gray">
						不太推薦
					</Text>
					<Text size="xs" color="gray">
						非常推薦
					</Text>
				</Group>

				{showError && (
					<Text color="red" size="sm" mt="xs">
						請選擇滿意度
					</Text>
				)}
			</Stack>

			<Stack w="100%" px="3.54vw">
				<Button
					fullWidth
					radius="xl"
					size="lg"
					color="black"
					style={{
						border: "2px solid #DDDDDD",
					}}
					onClick={goNext}
				>
					下一題
				</Button>
				<Button
					fullWidth
					variant="transparent"
					radius="xl"
					size="lg"
					color="black"
				/>
			</Stack>
		</Stack>
	);
}
